import styled from 'styled-components'
import { BaseInput, BaseTextArea } from 'components/Inputs/Base'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 30px;
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const FormField = styled(Container)`
  flex: ${props => props.stretch ? props.stretch : 1};
  justify-content: flex-end;
  align-items: center;
  padding: 0px;
  margin: 0px;
`

export const Row = styled(Container)`
  width: 100%;
  padding: 0px;
  gap: 10px;
  margin-bottom: 15px;
  flex-direction: row;
  align-items: flex-end;
`

export const Column = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  padding: 10px;
  gap: 12px;
`

export const ProductGrid = styled.div`
  width: 100%;
  display: grid;
  position: relative;
  gap: 10px;
  align-items: flex-start;
  margin: 6px 0px 3px;
  padding: 5px 0px 0px;
  border-top: 1px solid #F0F0F0;
  grid-template-columns: 260px 140px auto;
  cursor: auto;
`

export const BundleBlock = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: #FFFFFF;
  border: ${({ selected }) => selected ? '2px solid #FFC100' : 'none'};
  box-shadow: ${({ selected }) => selected ? 'none' : '0px 2px 10px -6px #252525'};
  border-radius: 10px;
  padding: 12px 15px;
  gap: 8px;
  cursor: pointer;

  &:hover {
    background-color: #F7F7F7;
  }

  p, div {
    margin: 0px;
    width: auto;
  }
`

export const InfoText = styled.p`
  color: #000000;
  font-size: 14px;
  text-align: center;
  margin-bottom: 0px;
`

export const Title = styled(InfoText)`
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
`

export const SubTitle = styled(Title)`
  font-size: 14px;
  margin-bottom: 2px;
`

export const Label = styled.label`
  text-align: center;
  color: #000000;
  line-height: 15px;
  margin-bottom: 7px;

  &:hover {
    cursor: pointer;
  }
`

export const MoneyText = styled(SubTitle)`
  color: #44CF6C;
`

export const MoneyTextMask = styled.p`
  color: #44CF6C;
  font-size: 18px;
  font-weight: bold;
  margin-top: 9px;
  margin-bottom: 0px;
  padding: 0px;
`

export const WarningText = styled.p`
  margin: 0px;
  text-align: center;
  font-size: 14px;
  font-weight: 200;
  color: #FF3939;
`

export const ErrorContainer = styled.div`
  padding: 8px;
  margin-bottom: 20px;
  width: 100%;
  border-radius: 15px;
  text-align: center;
  background-color: #FF3939;

  p {
    color: #FFFFFF;
    margin: 0px;
  }
`

export const Input = styled(BaseInput)`
  width: 100%;
`

export const TextArea = styled(BaseTextArea)`
  width: 100%;
`
